/**
 * Single source of truth for the left task-list columns: their stable ids and
 * default width factors (multiplied by `parseInt(rowWidth)`). Both the header
 * and the table read these ids when looking up per-column widths so resizing a
 * column keeps the two in sync.
 */
export type TaskListColumn = {
  id: string;
  factor: number;
};

export function getTaskListColumns(
  scheduleType: string,
  hasCheckbox: boolean
): TaskListColumn[] {
  const columns: TaskListColumn[] = [];

  if (hasCheckbox) columns.push({ id: "select", factor: 0.3 });

  columns.push(
    { id: "id", factor: 0.8 },
    { id: "wbs", factor: 0.8 },
    { id: "name", factor: 1.8 },
    { id: "plannedStart", factor: 0.6 },
    { id: "plannedEnd", factor: 0.6 }
  );

  if (scheduleType === "lookAhead") {
    columns.push(
      { id: "actualStart", factor: 0.6 },
      { id: "actualEnd", factor: 0.6 }
    );
  }

  if (scheduleType === "main") {
    columns.push(
      { id: "percentComplete", factor: 0.6 },
      { id: "plannedDuration", factor: 0.6 },
      { id: "remainingDuration", factor: 0.7 },
      { id: "actualDuration", factor: 0.6 },
      { id: "durationType", factor: 0.8 }
    );
  }

  return columns;
}

/** Minimum width (px) a column can be dragged down to. */
export const MIN_COLUMN_WIDTH = 40;

/** Build the default width map (px) for the current column set. */
export function buildDefaultColumnWidths(
  scheduleType: string,
  hasCheckbox: boolean,
  rowWidth: string
): Record<string, number> {
  const base = parseInt(rowWidth) || 0;
  const widths: Record<string, number> = {};
  for (const col of getTaskListColumns(scheduleType, hasCheckbox)) {
    widths[col.id] = base * col.factor;
  }
  return widths;
}
